export default {
    instanceManage: {
        page: {
            TransactionInstance: '事务实例',
            Status: '状态',
            businessType: '关联业务类型',
            businessID: '关联业务ID',
            Done: '完成',
            Failed: '失败',
            InProgress: '进行中',
            WaitingPulled: '等待被拉取',
        },
        table: {
            TransactionInstance: '事务实例',
            TransactionDescription: '事务描述',
            Status: '状态',
            ProgressBar: '进度条',
            StartTime: '开始时间',
            businessType: '关联业务类型',
            businessID: '关联业务ID',
        },
    },
};
